import React from "react";
import Link from "@qlik/qlik/src/components/Link";
import * as styles from "./styles.module.css";

/**
 * SimpleCard component
 * This component is used to render a simple card with a title, subheading, and a button.
 * @param {string} title - The title of the card.
 * @param {string} subHeading - The subheading of the card.
 * @param {string} className - The CSS class for the card.
 * @param {Object} button - The button object containing the link and text.
 * @returns {JSX.Element} The rendered SimpleCard component.
 */
const SimpleCard = ({ title, subHeading, className, button }) => {
    let to = "";
    if (button?.length) {
        const { internalLink, externalUrl } = button[0];
        to = internalLink ? internalLink.slug : externalUrl;
    }

    return (
        <Link className={`card group relative flex flex-col lg:py-7.5 lg:px-10  ${className} ${styles.cardpp}`} to={to}>
            {/* Render the subheading if it exists */}
            {subHeading && (
                <span
                    className="sub-heading block uppercase text-ocean text-xxs font-medium leading-none tracking-wide2 lg:text-sm lg:tracking-wide4"
                    suppressHydrationWarning={true}
                >
                    {subHeading}
                </span>
            )}
            {/* Render the title */}
            {title && (
                <h3 className="text-base font-semibold tracking-normal mb-auto leading-tight text-gray lg:text-xl overflow-hidden line-clamp-5 lg:line-clamp-2">
                    {title}
                </h3>
            )}
            {/* Render the button if it exists */}
            {button && (
                <span className="relative pr-4.5 text-sm font-bold leading-none text-gray after:absolute after:w-2 after:h-2 after:block after:border-t-2 after:border-l-2 after:border-stone after:-rotate-225  after:top-1 after:right-0 group-hover:text-green group-hover:after:border-green group-hover:duration-75">
                    {button[0].text}
                </span>
            )}
        </Link>
    );
};

export default SimpleCard;
